import { render, staticRenderFns } from "./CadastralAdjacencyView.vue?vue&type=template&id=73da032e&lang=pug"
import script from "./CadastralAdjacencyView.vue?vue&type=script&lang=js"
export * from "./CadastralAdjacencyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
